<section class="hero">

  <div class="hero-slider" *ngIf="bann?.length">

    <div
      class="hero-slide"
      *ngFor="let item of bann; let i = index"
      [class.active]="i === 0"
      [style.backgroundImage]="'url(' + item?.URL + ')'"
    >

      <div class="hero-overlay"></div>

      <div class="hero-content" *ngIf="boton === 1">
        <button (click)="editar()" class="btn-edit">
          Editar Banner
        </button>
      </div>

    </div>

  </div>

</section>





<section class="noticias">

  <div class="container">

    <div class="section-header">
      <h2>Últimas Noticias</h2>

      <button *ngIf="boton === 1" (click)="subirNoticia()" class="btn-primary">
        Agregar Noticia
      </button>
    </div>

    <div class="news-grid">

      <a
        class="news-card"
        *ngFor="let noticia of data"
        [routerLink]="'/admin/ver-noticia/' + noticia.ID"
      >

        <div class="news-img">
          <img [src]="noticia.ENLACE">
        </div>

        <div class="news-content">
          <h3>{{ noticia.ENCABEZADO }}</h3>
          <span>{{ noticia.FECHA }}</span>
        </div>

      </a>

    </div>

  </div>

</section>
